import React from "react";
import LegalLayout, { LegalBlock } from "@/components/legal/LegalLayout";

export default function Accessibility() {
  return (
    <LegalLayout
      title="Accessibility"
      seoTitle="Accessibility | ETAP"
      description="ETAP targets WCAG 2.2 AA. Learn how we support keyboard use, contrast, and reduced motion, and how to reach us if something is hard to use."
      path="/accessibility"
      lastUpdated="To be confirmed"
      intro="We want ETAP to work for everyone. This page states our target and how to reach us if you hit a barrier."
    >
      <LegalBlock heading="Our target">
        <p>
          ETAP aims to meet the Web Content Accessibility Guidelines, version 2.2, at level AA. We treat accessibility
          as a requirement, not an afterthought.
        </p>
      </LegalBlock>
      <LegalBlock heading="What we do">
        <p>
          Every interactive element is reachable by keyboard with a visible focus state. Text meets a contrast ratio of
          at least 4.5 to 1, including text over the mint accent and over imagery. Animations respect the reduced motion
          setting and show a designed static alternative. We use semantic HTML and clear labels for assistive
          technology.
        </p>
      </LegalBlock>
      <LegalBlock heading="Known limitations">
        <p>
          Placeholder for any known limitations and the plan to address them, to be confirmed as the product grows.
        </p>
      </LegalBlock>
      <LegalBlock heading="Contact us">
        <p>
          If you find something hard to use, tell us and we will help and fix it. Email{" "}
          <a href="mailto:accessibility@etaptax.com" className="font-semibold text-etap-primary underline underline-offset-2">
            accessibility@etaptax.com
          </a>
          .
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
